import './carousel-quote.scss';

import PubSub from 'pubsub-js';
import { TextColorCheck } from '../utils/textColorCheck';
import { PageEvents } from './page';

const COMPONENT_NAME = 'carousel-quote';
// const EVENT_KEY = COMPONENT_NAME;
const BEM = {
  BLOCK: COMPONENT_NAME,
  ELEMENT_SLIDER: 'carousel-quote__slider',
  ELEMENT_SLIDER_ITEM: 'carousel-quote__slider__item',
  ELEMENT_SLIDE: 'carousel-quote__slide',
};

/**
 * version    1.0
 * class      <type> (Carousel Quote)
 */
export class CarouselQuote {
  constructor($container = $('body')) {
    const self = this;

    this._vars = {
      maxHeight: 0,
    };

    // find elements
    this._els = {};
    this._els.container = $container;
    this._els.carouselQuote = this._els.container.find(`.${BEM.BLOCK}`);

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      this._els.carouselQuote.each(function () {
        self._initSingleInstance($(this));
      });
    });
  }

  // private methods

  _initSingleInstance($instanceEl) {
    const self = this;

    if ($instanceEl.find(`.${BEM.ELEMENT_SLIDE}`).length > 1) {
      // Se abbiamo uno slider
      self._initSlider($instanceEl);

      $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`).each(function () {
        const $slide = $(this);

        TextColorCheck._checkBackground($slide);
        self._getMaxHeightSlide($slide);
      });

      self._setMaxHeightSlide($instanceEl);
    } else {
      const $singleItem = $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`);

      // Se è presente un solo item
      TextColorCheck._checkBackground($singleItem);
      self._setDimensionSingleItem($singleItem);
    }
  }

  _getMaxHeightSlide($instanceEl) {
    const $slide = $instanceEl;

    if ($slide.height() > this._vars.maxHeight) {
      this._vars.maxHeight = $slide.height();
    }
  }

  _setMaxHeightSlide($instanceEl) {
    const $slide = $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`);

    $slide.css('height', this._vars.maxHeight);
  }

  _setDimensionSingleItem($instanceEl) {
    const $slide = $instanceEl.find('.carousel-quote__slide');

    if ($slide.outerHeight() > this._vars.maxHeight) {
      this._vars.maxHeight = $slide.outerHeight();
    }

    $instanceEl.css('height', this._vars.maxHeight);
  }

  // init the slider in case the instance contains more than one slide
  _initSlider($instanceEl) {
    const $sliderItems = $instanceEl.find(`.${BEM.ELEMENT_SLIDER_ITEM}`);
    const sliderAutoplay = $instanceEl.find(`.${BEM.ELEMENT_SLIDER}`).data('slider-autoplay');

    const optionsSlider = {
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      infinite: sliderAutoplay,
      autoplay: sliderAutoplay,
    };

    if ($sliderItems.length > 1) {
      $instanceEl.find(`.${BEM.ELEMENT_SLIDER}`).slick(optionsSlider);
    }
  }
}
